import { Autocomplete, IconButton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FIELD_TYPES, TABLE_FIELD_CONSTRAINTS } from '../../../utility/constants'
import { useAuthContext } from '../../../hooks/useAuthContext'
import { listDataService } from '../../../services/listDataService'
import DeleteIcon from '@mui/icons-material/Delete'

const FIELD_WIDTH = 220

const TableFieldConstraintItemEditUI = ({
  fields,
  constraintItem,
  updateConstraint = () => {},
  pivotFields,
  onDelete,
  selectedField,
}) => {
  const { user } = useAuthContext()
  const [listItems, setListItems] = useState([])

  useEffect(() => {
    ;(async () => {
      if (selectedField?.data_structure === FIELD_TYPES.LIST) {
        const listItemsData = await listDataService.getData(user, selectedField?.list_id)
        setListItems(listItemsData.data)
      }
    })()
  }, [selectedField, user])

  const getSelectedField = (fieldId, fields) => {
    const field = fields?.find((it) => it.id == fieldId)

    return field
      ? {
          value: field,
          label: field.field_template_name,
        }
      : null
  }

  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        marginTop: 12,
        marginBottom: 10,
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {/* Constraint */}
      <Autocomplete
        size="small"
        value={
          constraintItem?.constraint
            ? {
                value: constraintItem.constraint,
                label: constraintItem.constraint,
              }
            : null
        }
        options={Object.entries(TABLE_FIELD_CONSTRAINTS).map(([key, value]) => ({
          value,
          label: key,
        }))}
        sx={{ width: FIELD_WIDTH }}
        renderInput={(params) => <TextField {...params} label="Constraint" size="small" />}
        onChange={(e, v) => {
          updateConstraint({
            ...constraintItem,
            constraint: v?.value || null,
          })
        }}
      />

      {/* MIN_1_MATCH */}
      {constraintItem.constraint === TABLE_FIELD_CONSTRAINTS.MIN_1_MATCH &&
        (selectedField?.data_structure === FIELD_TYPES.LIST ? (
          <Autocomplete
            size="small"
            id="list-items-dropdown"
            options={listItems || []}
            getOptionLabel={(option) => option?.value || ''}
            value={listItems.find((item) => item.id == constraintItem.constant_value) || null}
            onChange={(e, v) =>
              updateConstraint({
                ...constraintItem,
                constant_value: v?.id || null,
              })
            }
            sx={{ width: FIELD_WIDTH }}
            renderInput={(params) => <TextField {...params} label="Select Value" size="small" />}
          />
        ) : (
          <TextField
            size="small"
            sx={{ width: FIELD_WIDTH }}
            value={constraintItem.constant_value || ''}
            label="Value"
            variant="outlined"
            onChange={(e) =>
              updateConstraint({
                ...constraintItem,
                constant_value: e.target.value || null,
              })
            }
          />
        ))}

      {/* UNIQUE */}
      {constraintItem.constraint === TABLE_FIELD_CONSTRAINTS.UNIQUE && (
        <Autocomplete
          size="small"
          id="autocomplete-pivot-field"
          value={getSelectedField(constraintItem.pivot_field_template_id, pivotFields)}
          options={pivotFields.map((it) => ({
            value: it,
            label: it.field_template_name,
          }))}
          sx={{ width: FIELD_WIDTH }}
          renderInput={(params) => (
            <TextField {...params} label="Pivot Field (Optional)" color="secondary" size="small" />
          )}
          onChange={(e, v) => {
            updateConstraint({
              ...constraintItem,
              pivot_field_template_id: v?.value?.id || null,
            })
          }}
        />
      )}

      <IconButton size="small" onClick={() => onDelete(constraintItem.id)}>
        <DeleteIcon fontSize="small" />
      </IconButton>
    </div>
  )
}

export default TableFieldConstraintItemEditUI
